import {NgModule} from "@angular/core";
import {CommonModule} from '@angular/common';
import {ConfirmComponent} from "./confirm.component";
import {ModalModule} from "ng2-bootstrap";

@NgModule({
    declarations: [
        ConfirmComponent,
    ],
    imports: [
        ModalModule,
        CommonModule
    ],
    exports: [
        ConfirmComponent,
    ],
})

export class ConfirmModule {

}


// WEBPACK FOOTER //
// ./src/app/modules/confirm/confirm.module.ts